// Clear button («×») at the right end of every search box while it has text. One piece for the
// whole app, so new search boxes get it too: a search box is an input of type "search", one whose
// id or class mentions "search", or one whose placeholder starts with «Buscar». A box that has its
// own clear button opts out with data-search-clear="off".
const SearchClear = {
    SELECTOR: 'input[type="search"], input[type="text"][id*="search"], input[type="text"][class*="search"], input[type="text"][placeholder^="Buscar"]',
    buttons: new WeakMap(),

    isSearch(el) {
        return el instanceof HTMLInputElement && el.matches(this.SELECTOR) && el.dataset.searchClear !== 'off' && !el.disabled && !el.readOnly;
    },

    /** Shows the button while the box has text, placed at the box's right edge. */
    sync(input) {
        let button = this.buttons.get(input);
        if (!input.value || !input.isConnected || !input.parentElement) {
            if (button) button.hidden = true;
            return;
        }
        const parent = input.parentElement;
        if (!button || button.parentElement !== parent) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'search-clear';
            button.setAttribute('aria-label', 'Borrar búsqueda');
            button.title = 'Borrar búsqueda';
            // A drawn cross, not an <i> icon: search boxes style their <i> (the magnifier) and
            // those rules would move it too.
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 12 12');
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
            const cross = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            cross.setAttribute('d', 'M2 2l8 8M10 2l-8 8');
            svg.append(cross);
            button.append(svg);
            // Keep the focus in the box while clicking.
            button.addEventListener('mousedown', event => event.preventDefault());
            button.addEventListener('click', () => this.clear(input));
            if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
            parent.append(button);
            this.buttons.set(input, button);
            input.classList.add('has-search-clear');
        }
        // The box may not fill its container: measure where its right edge is.
        const styles = getComputedStyle(parent), outer = parent.getBoundingClientRect(), box = input.getBoundingClientRect();
        button.style.right = `${outer.right - (parseFloat(styles.borderRightWidth) || 0) - box.right + 8}px`;
        button.style.top = `${box.top - outer.top - (parseFloat(styles.borderTopWidth) || 0) + box.height / 2}px`;
        button.hidden = false;
    },

    /** Empties the box and tells the view, which then shows everything again. */
    clear(input) {
        input.value = '';
        for (const type of ['input', 'keyup', 'search']) input.dispatchEvent(new Event(type, { bubbles: true }));
        input.focus();
        this.sync(input);
    },

    start() {
        document.addEventListener('input', event => { if (this.isSearch(event.target)) this.sync(event.target); }, true);
        document.addEventListener('focusin', event => { if (this.isSearch(event.target)) this.sync(event.target); });
        // Views redraw their boxes, sometimes keeping the text: check them after each redraw
        // (the observer already groups the changes of one redraw into a single call).
        new MutationObserver(() => {
            for (const el of document.querySelectorAll(this.SELECTOR)) {
                if (this.isSearch(el) && (el.value || this.buttons.has(el))) this.sync(el);
            }
        }).observe(document.body, { childList: true, subtree: true });
    }
};

window.SearchClear = SearchClear;
if (document.body) SearchClear.start();
else document.addEventListener('DOMContentLoaded', () => SearchClear.start());
